import * as React from 'react'

export const useKeyedRef = <T>(_: string, initialValue: T) =>
  React.useRef(initialValue)
